/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlay: {
  name: 'play';
  data: string;
} = {
  name: 'play',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.788 2.547a.5.5 0 0 1 .532.069l6 5a.5.5 0 0 1 0 .768l-6 5A.5.5 0 0 1 4.5 13V3a.5.5 0 0 1 .288-.453Zm.712 1.52v7.865L10.219 8 5.5 4.068Z" fill="currentColor"/></svg>`,
};
